import type * as React from "react"

import { cn } from "@/lib/utils"

import { Label } from "./label"

interface AttributeDisplayProps {
  label: string
  value: string | React.ReactNode
  className?: string
}

export default function AttributeDisplay({
  label,
  value,
  className,
}: AttributeDisplayProps) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <Label>{label}</Label>
      <div className="text-muted-foreground text-sm font-normal">{value}</div>
    </div>
  )
}
